import { useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useBulkActions } from 'modules/expenses/components/expenses/Detail/hooks/useBulkActions'
import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { isMyExpensesSection } from 'modules/expenses/lib/common'
import { Expensable } from 'modules/expenses/types/Expensable'

interface ReimburseExpensableThroughSepaButtonProps {
  expensable: Expensable
  reimburseThroughSepaEnabled: boolean
  onLoadingChange?: (loading: boolean) => void
  disabled?: boolean
}

const ReimburseExpensableThroughSepaButton = ({
  expensable,
  reimburseThroughSepaEnabled,
  onLoadingChange,
  disabled,
}: ReimburseExpensableThroughSepaButtonProps) => {
  const { section } = useOutletContext<RouteContextParams>()

  const { addToPayment, submitting } = useBulkActions()

  useEffect(() => {
    onLoadingChange?.(submitting)
  }, [submitting, onLoadingChange])

  const isApproved = expensable.status == 'approved'
  const isManual = expensable?.expense?.creationType == 'manual'
  const isReimbursableThroughSepaExpense =
    expensable.type == 'expense' &&
    expensable.expense?.payment === 'reimbursable' &&
    (expensable?.reimbursableCurrency || expensable?.currency)
  const showReimburseThroughSepaButton =
    isApproved &&
    isManual &&
    isReimbursableThroughSepaExpense &&
    reimburseThroughSepaEnabled &&
    !isMyExpensesSection(section)

  if (showReimburseThroughSepaButton) {
    return (
      <Button
        type="primary"
        disabled={submitting || disabled}
        onClick={addToPayment}
        loading={submitting}
        iconName={submitting ? 'upload' : undefined}
      >
        {i18n.t('expenses_v2.buttons.reimburse_via_sepa')}
      </Button>
    )
  }
}

export default ReimburseExpensableThroughSepaButton
